module.exports = __webpack_public_path__ + "2ffa264c422ccadd2296c0a86582362d.svg";